
export const formatCpfOrCnpj = (value) => {
  let cnpjOrCpfFormated;

  if(value?.length > 11) {
    cnpjOrCpfFormated = value?.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  } else {
    cnpjOrCpfFormated = value?.replace(/^(\d{3})(\d{3})(\d{3})/, "$1.$2.$3-")
  }

  return cnpjOrCpfFormated;
}